import ChatAssist from './containers/ChatAssist';
import pageLayoutHoc from '../../hocs/pageLayoutHoc';

export const chatAssistRoutes = [
  {
    path: '/Kai',
    component: pageLayoutHoc(ChatAssist),
    key: 'chat_rep',
  },
  {
    path: '/Nea',
    component: pageLayoutHoc(ChatAssist),
    key: 'chat',
  },
];
